



























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class DischargePlanningSection extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any;
  @Prop({ default: false }) readonly disabled!: boolean;

  form: any = {
    usia_gt60: false,
    hambatan_mobilisasi: false,
    tergantung_adl: false,
    keluarga_merawat: "",
    dekat_tetangga: false,
    ventilasi_rumah: false,
    pencahayaan: "baik",
    lingkungan_padat: false,
    transportasi: "motor",
    transportasi_lain: "",
    asuransi: "",
    pertolongan_sakit: []
  };

  pertolonganOptions = [
    { text: "Dokter Praktik", value: "dokter" },
    { text: "Klinik Swasta", value: "klinik" },
    { text: "Puskesmas", value: "puskesmas" },
    { text: "Rumah Sakit", value: "rs" }
  ];

  created() {
    if (this.value && typeof this.value === "object") {
      this.form = { ...this.form, ...this.value };
    }
  }


  @Watch("form", { deep: true })
  onFormChange(val: any) { this.$emit("input", { ...val }); }

  syncFromValue(val: any) {
    if (!val) return;
    this.form = { ...this.form, ...val };
    if (!Array.isArray(this.form.pertolongan_sakit)) this.form.pertolongan_sakit = [];
  }
}
